<template>
	<div class="bg-primary w-screen h-screen flex items-center justify-center">
		<div class="text-white text-center rounded-sm box-login">
			<img class="mx-auto mb-3" :src="assetsUrl + '/logo-light.svg'" width="150px" :alt="brand" />
			<div v-if="show">
				<p class="font-bold mb-5">{{ $t('change_password') }}</p>
				<div class="mb-3">
					<input v-model="password" class="input-login p-2 w-100" type="password" v-bind:placeholder="$t('new_password')" />
					<div v-if="$v.password.$dirty" class="text-left">
						<div class="font-12 text-red-500 mt-1" v-if="!$v.password.required">* {{ $t('new_password_requerida') }}</div>
						<div class="font-12 text-red-500 mt-1" v-if="!$v.password.minLength">* {{ $t('new_password_invalid') }}</div>
					</div>
				</div>
				<div>
					<input v-model="confirm_password" class="input-login p-2 w-100" type="password" v-bind:placeholder="$t('confirm_new_password')" />
					<div v-if="$v.confirm_password.$dirty" class="text-left">
						<div class="font-12 text-red-500 mt-1" v-if="!$v.confirm_password.required">* {{ $t('confirm_password_requerida') }}</div>
						<div class="font-12 text-red-500 mt-1" v-if="!$v.confirm_password.minLength">* {{ $t('confirm_password_invalid') }}</div>
						<div class="font-12 text-red-500 mt-1" v-if="!$v.confirm_password.sameAsPassword">* {{ $t('new_password_validation') }}</div>
					</div>
				</div>
				<button class="w-100 bg-white text-primary border-0 rounded-full p-2 mt-4 shadow-md outline-none cursor-pointer hover:text-primary focus:outline-none" @click="submit">
					<span class="font-bold">{{ $t('change') }}</span>
				</button>
			</div>
			<div class="my-5" v-else>
				{{ server_message }}
			</div>
			<div class="mt-3" v-if="error">
				<p>
					{{ server_message }}
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import { required, minLength, sameAs } from 'vuelidate/lib/validators'

export default {
	data() {
		return {
			brand: process.env.VUE_APP_BRAND,
			assetsUrl: process.env.VUE_APP_ASSETS_URL,
			password: null,
			confirm_password: null,
			error: false,
			show: true,
			server_message: null,
		}
	},
	validations: {
		password: {
			required,
			minLength: minLength(8),
		},
		confirm_password: {
			required,
			minLength: minLength(8),
			sameAsPassword: sameAs('password'),
		},
	},
	props: {
		token: String,
	},
	methods: {
		submit() {
			this.error = false
			this.$v.$touch()
			if (!this.$v.$invalid) {
				let data = {
					token: this.token,
					password: this.password,
				}
				this.$store.dispatch('isLoading', true)
				this.$axios
					.post('auth/password_reset', data)
					.then(() => {
						this.$store.dispatch('isLoading', false)
						this.$alert( this.$t('change_password_success'), this.$t('change_password'), 'question')
							.then(() => {
								this.$router.push('/login')
							})
					})
					.catch(error => {
						if (error.response.status === 401) {
							this.$store.dispatch('login/logout')
						}
						this.$store.dispatch('isLoading', false)
						this.server_message = this.$t('error_token')
						this.error = true
					})
			}
		},
	},
}
</script>

<style scoped>
.box-login {
	padding: 3rem;
	width: 400px;
}
.w-100 {
	width: 100%;
}
.input-login {
	border-color: transparent;
	color: #363636;
	border-radius: 5px;
}
.input-login:focus {
	-webkit-box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.5);
	box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.5);
}
.font-12 {
	font-size: 12px;
}
</style>
